import React from "react";
import dynamic from "next/dynamic";
import { format } from "date-fns";
// import Player from "components/player/player";
// import EmbedPlayer from "components/player/embedPlayer";
import { PlayerProvider } from "./playerContext";
import ClockIcon from "components/Icons/ClockIcon";
import LocationIcon from "components/Icons/LocationIcon";
import DateIcon from "components/Icons/DateIcon";
import { getHost } from "../helper";

const Player = dynamic(() => import("../player/player"), { ssr: false });
const EmbedPlayer = dynamic(() => import("../player/embedPlayer"), {
  ssr: false,
});

const BackDropElement = ({ children }) => (
  <div className="event-backdrop-filter absolute bottom-0 left-0 w-full h-full max-w-xl max-h-64 rounded-tr-[10px] tablet-100:left-1/2 tablet-100:bottom-[-65px] tablet-100:rounded-bl-[10px] tablet-100:-translate-x-1/2 phone-200:left-6 tablet-100:rounded-tl-[10px] tablet-100:rounded-br-[10px] phone-200:transform-none phone-200:right-6 phone-200:w-auto phone-300:top-[190px] phone:p-4 phone:top-[130px] phone:min-h-[15rem]">
    {children}
  </div>
);

const BackDropElementAlt = ({ children }) => (
  <div className="py-4 px-8 event-backdrop-filter absolute bottom-0 right-0 w-full max-w-xl rounded-tl-[10px] desktopSmall:right-1/2 desktopSmall:translate-x-1/2 desktopSmall:rounded-[10px] desktopSmall:max-w-[90%] desktopSmall:w-[fit-content] desktopSmall:bottom-1/2 tablet-100:bottom-auto tablet-100:top-0 tablet-100:rounded-tr-none tablet-100:rounded-tl-none">
    {children}
  </div>
);

// TODO: topic was set to [] to get by build
const StateHandler = ({ data, church, isDvr = false }) => {
  const opts = {
    isLive: data.state === 0,
    subtitles: data.subtitles,
  };
  const analytics = {
    eventId: data._id,
    accountId: data.account._id,
    playerLocation: "Virtuaalikirkko",
    isLive: data.state === 0,
    isDvr,
    liveChannel: data.state === 0 ? data.liveChannel._id : undefined,
    title: data.title,
    category: data?.categories?.map((c) => c.name).join(","),
  };
  const date = new Date(data?.publishingDate);

  const playerWithSlides =
    data?.slides?.enabled && data?.slides?.set?.length > 0;

  switch (data.state) {
    case 0:
      return (
        <>
          {playerWithSlides ? (
            <>
              {data?.urlName && data?.account?.urlName && (
                <EmbedPlayer
                  src={`//${data?.account?.urlName}.${getHost(
                    window?.location?.host
                  )}/${data?.urlName}?embed-view=1&hide-chat=1`}
                />
              )}
            </>
          ) : (
            <PlayerProvider>
              <Player
                hlsUrl={data.streams?.live?.hls}
                opts={opts}
                analytics={analytics}
              />
            </PlayerProvider>
          )}
        </>
      );
    case 1:
      return (
        <>
          {playerWithSlides && data?.sync?.slides?.length > 0 ? (
            <>
              {data?.urlName && data?.account?.urlName && (
                <EmbedPlayer
                  src={`//${data?.account?.urlName}.${getHost(
                    window?.location?.host
                  )}/${data?.urlName}?embed-view=1&hide-chat=1`}
                />
              )}
            </>
          ) : (
            <PlayerProvider>
              <Player
                hlsUrl={data.streams.hls}
                opts={opts}
                analytics={analytics}
              />
            </PlayerProvider>
          )}
        </>
      );
    case 2:
      return (
        <BackDropElement>
          <h3 className="text-3xl text-white font-semibold flex items-center justify-center text-center h-full phone:text-xl">
            {data?.hidden?.od}
          </h3>
        </BackDropElement>
      );
    case 3:
      return (
        <>
          <BackDropElement>
            <div className="h-full flex flex-col items-center justify-center">
              <h3 className="text-3xl text-white font-semibold">
                Lähetyksen tiedot
              </h3>
              <div className="mt-8 flex items-start">
                <div className="flex flex-col items-center justify-center mr-8">
                  <LocationIcon width={28} height={37} />
                  <span className="text-center text-white font-semibold mt-5 max-w-[7rem] break-all phone-200:text-sm truncate-text three-lines">
                    {church?.descriptionParsed?.data?.address}
                  </span>
                </div>
                <div className="flex flex-col items-center justify-center mr-8">
                  <DateIcon width={32} height={37} />
                  <span className="text-center text-white font-semibold mt-5  phone-200:text-sm">
                    {format(date, "dd.MM.yyyy")}
                  </span>
                </div>
                <div className="flex flex-col items-center justify-center">
                  <ClockIcon width={37} height={37} />
                  <span className="text-center text-white font-semibold mt-5  phone-200:text-sm">
                    Alkaa <br />
                    {format(date, "HH.mm")}
                  </span>
                </div>
              </div>
            </div>
          </BackDropElement>
          {data?.hidden?.live && (
            <BackDropElementAlt>
              <h4 className="text-xl text-white font-semibold text-center truncate-text four-lines phone:text-xl">
                {data.hidden.live}
              </h4>
            </BackDropElementAlt>
          )}
        </>
      );
    case 6:
      return (
        <BackDropElement>
          <h3 className="text-3xl text-white font-semibold flex items-center justify-center text-center h-full phone:text-xl">
            {data?.hidden?.pause}
          </h3>
        </BackDropElement>
      );
    default:
      return <div />;
  }
};

export default StateHandler;
